type Success = string;
type Error = string;

export interface NotificationState {
  success?: Success;
  error?: Error;
}

export enum NotificationType {
  SUCCESS = 'success',
  ERROR = 'error',
}
